var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/master.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-1d565eb8!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/master.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Master.vue
// module id = 625
// module chunks = 1